const { State } = require("@/utils/popup/Error.js");

export const Action = {
    0: "goToUpload",
    1: "goToProductShelves",
};

export const errorDefinitions = {
    2001: {
        title: "จำนวนเอกสารไม่ครบเงื่อนไขในการสมัคร",
        detail: "กรุณาตรวจสอบเอกสารประกอบการสมัครอีกครั้ง",
        state: State["1"],
        callbackAction: "None",
    },
    4001: {
        title: "ท่านทำรายการไม่ถูกต้อง",
        detail: "กรุณาทำรายการใหม่อีกครั้ง",
        state: State["1"],
        callbackAction: "None",
    },
    4005: {
        title: "หมดเวลาทำรายการ",
        detail: "กรุณาลองใหม่อีกครั้ง",
        state: State["0"],
        callbackAction: Action["0"],
        isGaTagging : true,
        isGaDefault : false,
    },
    4006: {
        title: "หมดเวลาทำรายการ",
        detail: "กรุณาลองใหม่อีกครั้ง",
        state: State["0"],
        callbackAction: Action["0"],
        isGaTagging : true,
        isGaDefault : false,
    },
    4007: {
        title: "ใบสมัครถูกยกเลิก",
        detail:
            "เนื่องจากคุณทำรายการเกินเวลาที่กำหนด<br />คุณสามารถสมัครสินเชื่อได้อีกครั้งผ่านแอปฯ เป๋าตัง<br />หรือ Krungthai NEXT<br />ขอขอบคุณในความไว้วางใจ และหวังเป็น<br />อย่างยิ่งว่าจะได้ให้บริการคุณในโอกาสต่อไป",
        state: State["0"],
        callbackAction: Action["1"],
        isGaTagging : true,
        isGaDefault : true,
    },
    4009: {
        title: "หมดเวลาทำรายการ",
        detail: "กรุณาลองใหม่อีกครั้ง",
        state: State["0"],
        callbackAction: Action["0"],
        isGaTagging : true,
        isGaDefault : false,
    },
    5003: {
        title: "ประเภทของไฟล์ไม่ถูกต้อง",
        detail: "กรุณาเลือกประเภทของไฟล์ได้แก่ PDF, PNG หรือ JPG",
        state: State["1"],
        callbackAction: Action["0"],
    },
    5004: {
        title: "ไฟล์มีปัญหา",
        detail: "ไม่สามารถเปิดไฟล์ได้ กรุณาลองใหม่อีกครั้ง",
        state: State["1"],
        callbackAction: Action["1"],
    },
    5007: {
        title: "ไม่สามารถดำเนินการได้ในขณะนี้",
        detail: "กรุณาลองใหม่ภายหลัง",
        state: State["1"],
        callbackAction: Action["1"],
        isGaTagging : true,
        isGaDefault : false,
        isGaSentErrorCode : true,
        GaErrorCode: "5007",
    },
    5008: {
        title: "หมดเวลาทำรายการ",
        detail: "กรุณาลองใหม่อีกครั้ง",
        state: State["0"],
        callbackAction: Action["0"],
        isGaTagging : true,
        isGaDefault : false,
    },
    5009: {
        title: "ไม่สามารถดำเนินการได้ในขณะนี้",
        detail: "กรุณาลองใหม่ภายหลัง",
        state: State["1"],
        callbackAction: Action["1"],
        isGaTagging : true,
        isGaDefault : false,
        isGaSentErrorCode : true,
        GaErrorCode: "5009",
    },
    5010: {
        title: "ไม่สามารถดำเนินการได้ในขณะนี้",
        detail: "กรุณาลองใหม่ภายหลัง",
        state: State["1"],
        callbackAction: Action["1"],
        isGaTagging : true,
        isGaDefault : false,
        isGaSentErrorCode : true,
        GaErrorCode: "5010",
    },
    default: {
        title: "ไม่สามารถดำเนินการได้ในขณะนี้",
        detail: "กรุณาลองใหม่ภายหลัง",
        state: State["1"],
        callbackAction: Action["1"],
        isGaTagging : true,
        isGaDefault : false,
        isGaSentErrorCode : true,
        GaErrorCode: ""
    },
};
